export default __webpack_public_path__ + "static/media/5.2e6704f7.jpg";